import { useSelector } from "react-redux";
import { selectRenderAdsForUser } from "rivals/redux/rails/selectors";
import DistroScaleAd from ".";

/**
 * Redux wrapper around DistroScaleAd component that selects ad permissions from the store
 *
 * @returns DistroscaleAd component
 */
export default function DistroScaleAdWrapper(): React.JSX.Element {
  const shouldRenderAdsForUser = useSelector(selectRenderAdsForUser);

  return <DistroScaleAd shouldRenderAdsForUser={shouldRenderAdsForUser} />;
}
